export default class GeoCoordinates {
  latitude = ''
  longitude = ''
}
